
import React, { useEffect } from "react";

// CSS-in-JS para o efeito
const styles: Record<string, React.CSSProperties> = {
  root: {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    overflow: "hidden",
    background: "linear-gradient(40deg, rgb(108,0,162), rgb(0,17,82))",
    zIndex: 0,
    pointerEvents: "none",
  },
  gradientsContainer: {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    filter: "blur(40px)", // SVG goo não é trivial em React, blur aproxima
  },
  circle: {
    position: "absolute",
    width: "80%",
    height: "80%",
    top: "10%",
    left: "10%",
    borderRadius: "50%",
    opacity: 1,
    mixBlendMode: "hard-light",
    pointerEvents: "none",
  },
  circle2: {
    position: "absolute",
    width: "80%",
    height: "80%",
    top: "10%",
    left: "10%",
    borderRadius: "50%",
    opacity: 1,
    mixBlendMode: "hard-light",
    pointerEvents: "none",
  },
  circle3: {
    position: "absolute",
    width: "80%",
    height: "80%",
    top: "calc(10% + 200px)",
    left: "calc(10% - 500px)",
    borderRadius: "50%",
    opacity: 1,
    mixBlendMode: "hard-light",
    pointerEvents: "none",
  },
  circle4: {
    position: "absolute",
    width: "80%",
    height: "80%",
    top: "10%",
    left: "10%",
    borderRadius: "50%",
    opacity: 0.7,
    mixBlendMode: "hard-light",
    pointerEvents: "none",
  },
  circle5: {
    position: "absolute",
    width: "160%",
    height: "160%",
    top: "calc(50% - 40%)",
    left: "calc(50% - 40%)",
    borderRadius: "50%",
    opacity: 1,
    mixBlendMode: "hard-light",
    pointerEvents: "none",
  },
};

// Cores
const gradients = [
  {
    style: styles.circle,
    color: "18,113,255",
    animation: "moveVertical 30s ease-in-out infinite",
  },
  {
    style: styles.circle2,
    color: "221,74,255",
    animation: "moveInCircle 20s reverse infinite",
  },
  {
    style: styles.circle3,
    color: "100,220,255",
    animation: "moveInCircle 40s linear infinite",
  },
  {
    style: styles.circle4,
    color: "200,50,50",
    animation: "moveHorizontal 40s ease-in-out infinite",
  },
  {
    style: styles.circle5,
    color: "180,180,50",
    animation: "moveInCircle 20s ease-in-out infinite",
  },
];

// Keyframes
const keyframes = `
@keyframes moveInCircle {
  0% { transform: rotate(0deg); }
  50% { transform: rotate(180deg); }
  100% { transform: rotate(360deg); }
}
@keyframes moveVertical {
  0% { transform: translateY(-50%); }
  50% { transform: translateY(50%); }
  100% { transform: translateY(-50%); }
}
@keyframes moveHorizontal {
  0% { transform: translateX(-50%) translateY(-10%); }
  50% { transform: translateX(50%) translateY(10%); }
  100% { transform: translateX(-50%) translateY(-10%); }
}
`;

// Injeta keyframes no documento
function injectKeyframes() {
  if (typeof document === "undefined") return;
  if (document.getElementById("liquid-iridescent-keyframes")) return;
  const style = document.createElement("style");
  style.id = "liquid-iridescent-keyframes";
  style.innerHTML = keyframes;
  document.head.appendChild(style);
}

export default function LiquidIridescentBackground() {
  useEffect(() => {
    injectKeyframes();
  }, []);

  return (
    <div style={styles.root}>
      <div style={styles.gradientsContainer}>
        {gradients.map((g, i) => (
          <div
            key={i}
            style={{
              ...g.style,
              background: `radial-gradient(circle at center, rgba(${g.color},0.8) 0, rgba(${g.color},0) 50%)`,
              animation: g.animation,
            }}
          />
        ))}
      </div>
    </div>
  );
}
